export const MAX_FILES_COUNT = 30;
